<template>
  <div className="check-root">
    <div>{{ msg }}</div>
  </div>
</template>

<script>
import requestHTAPI from '@/axios/HantangTax'
import {getUrlParam} from '@/libs/utils'

export default {
  name: 'checkRoot',
  data() {
    return {
      code: '',
      url: '',
      msg: '授权中，请稍候...'
    }
  },
  mounted() {
    this.code = getUrlParam('code')
    const rawUrl = getUrlParam('url')
    this.url = rawUrl ? decodeURIComponent(rawUrl) : ''

    // 关键判断
    if (!this.code) {
      this.msg = '授权码缺失，请重新进入'
      this.$toast.fail('授权码缺失，请重新进入')
      return
    }
    if (!this.url) {
      this.msg = '跳转地址缺失'
      this.$toast.fail('跳转地址缺失')
      return
    }

    this.sendCode()
  },
  methods: {
    sendCode() {
      const formData = new FormData()
      formData.append('code', this.code)

      requestHTAPI.sendCode(formData).then(res => {
        // 先把完整返回打出来，方便排查
        console.log('后端返回：', res.data)

        if (res.data.code === '0000' || res.data.code === 0) {
          const data = res.data.data || {}
          if (data.token) {
            sessionStorage.setItem('TOKEN', data.token)
          }
          // 用完立刻清掉，防止刷新重复使用
          this.code = ''
          this.$router.replace({path: this.url})
        } else {
          // 尽量显示后端返回的真实错误信息
          const errMsg = res.data.msg || res.data.message || '请重新授权'
          this.msg = errMsg
          this.$toast.fail(errMsg)
        }
      }).catch(error => {
        console.error('请求异常：', error)
        this.msg = '服务异常，请重新授权'
        this.$toast.fail('服务异常，请重新授权')
      })
    }
  }
}
</script>

<style scoped>
.check-root {
  padding: 40px 20px;
  text-align: center;
  color: #666;
}
</style>
